import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';

import SectionFeaturedIn from '../../components/SectionFeaturedIn/SectionFeaturedIn';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error } = props;

  const data = pageAssetsData?.[camelize(ASSET_NAME)]?.data;
  const sections = data?.sections || [];

  // Inject Featured In section after Hero (index 0)
  const sectionsWithFeaturedIn = [
    ...sections.slice(0, 1),
    {
      sectionType: 'featuredIn',
      sectionId: 'featured-in-section',
    },
    ...sections.slice(1),
  ];

  const newData = data ? { ...data, sections: sectionsWithFeaturedIn } : data;

  return (
    <PageBuilder
      pageAssetsData={newData}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
      isLandingPage={true}
      options={{
        sectionComponents: {
          featuredIn: { component: SectionFeaturedIn },
        },
      }}
    />
  );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
